import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  IconButton,
  FormControlLabel,
  Checkbox,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import { Close, Save, ShoppingCart, ExpandMore, Refresh } from '@mui/icons-material';

import ClientAPI from '../service/ClientAPI';
import Events from '../service/Events';

class UpdateCustomerProductsPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      cachedOrders: null,
      orders: []
    }
  }

  handleClose = () => {
    this.setState({ show: false });
    this.props.onClose();
  }

  handleSubmit = (ev) => {
    if (this.props.customSubmit) {
      this.props.customSubmit(this.state.cachedOrders);
    }
    else {
      console.log(this.state.cachedOrders);
      ClientAPI.UpdateMyOrders({ orders: this.state.cachedOrders })
        .then((_res) => {
          window.location.reload();
        })
        .catch(console.error);
    }

    ev.preventDefault();
  }

  componentDidUpdate() {
    if (this.state.show !== this.props.show) {
      this.setState({ 
        show: this.props.show, 
        orders: this.props.orders, 
        cachedOrders: this.props.orders.map(o => { return { ...o, Confirmed: o.Confirmed || false } }) 
      });
    }
  }

  handleAmountChange = (ev, orderID) => {
    var _ind = this.state.orders.findIndex(_order => _order.orderID === orderID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedOrders[_ind].Amount = parseInt(ev.target.value);

    this.setState({ cachedOrders: this.state.cachedOrders });
  }

  handleConfirmedChange = (ev, orderID) => {
    var _ind = this.state.orders.findIndex(_order => _order.orderID === orderID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedOrders[_ind].Confirmed = ev.target.checked;

    this.setState({ cachedOrders: this.state.cachedOrders });
  }

  resetEntry = (orderID) => {
    var _ind = this.state.orders.findIndex(_order => _order.orderID === orderID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedOrders[_ind].Amount = this.state.orders[_ind].Amount;
    this.state.cachedOrders[_ind].SortID = this.state.orders[_ind].SortID;
    this.state.cachedOrders[_ind].Confirmed = this.state.orders[_ind].Confirmed || false;

    this.setState({ cachedOrders: this.state.cachedOrders });
  }

  cofirmOrder = (orderID) => {
    ClientAPI.ConfirmOrder(orderID)
      .then(() => window.location.reload())
      .catch(console.error);
  }

  render() {
    return (
      this.state.cachedOrders ?
        (
          <Dialog
            open={this.state.show}
            onHide={this.handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: { xs: '12px', sm: '20px' },
                overflow: 'hidden',
                margin: { xs: '16px', sm: '32px' },
                maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
              }
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={this.handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'white',
                zIndex: 1,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
              }}
            >
              <Close />
            </IconButton>

            {/* Header with gradient */}
            <Box
              sx={{
                background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                pt: { xs: 3, sm: 4 },
                pb: { xs: 2.5, sm: 3 },
                px: { xs: 2, sm: 3 },
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 1.5, sm: 2 }
              }}
            >
              <ShoppingCart sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
              <DialogTitle sx={{ p: 0, flex: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                  Produkt Übersicht
                </Typography>
              </DialogTitle>
            </Box>

            <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
              <Box component="form" onSubmit={this.handleSubmit} id="update-orders-form">
                {this.state.cachedOrders.map((_order, index) => (
                  <Accordion
                    key={_order.orderID}
                    defaultExpanded={index === 0}
                    sx={{
                      mb: 2,
                      borderRadius: '12px !important',
                      '&:before': { display: 'none' },
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      sx={{
                        bgcolor: '#f5f5f5',
                        borderRadius: '12px',
                        '&:hover': { bgcolor: '#e8f5e9' }
                      }}
                    >
                      <Typography sx={{ fontWeight: 600 }}>{_order.Name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ pt: 3 }}>
                      <TextField
                        fullWidth
                        label="Produktname"
                        name={_order.Name}
                        value={_order.Name}
                        disabled
                        sx={{ mb: 3 }}
                      />

                      {_order.isFixed ? (
                        <Box>
                          <TextField
                            fullWidth
                            label="Preis"
                            value={`${_order.isFixed ? _order.Price + "€" : _order.CustomPrice !== 0 ? _order.CustomPrice + "€" : "Betrag noch nicht berechnet..."}`}
                            disabled
                            sx={{ mb: 3 }}
                          />

                          <TextField
                            fullWidth
                            label="Gesamtpreis"
                            value={`${(_order.Price * (_order.Amount ? _order.Amount : 0)).toFixed(2)}€`}
                            disabled
                            sx={{ mb: 3 }}
                          />
                        </Box>
                      ) : <></>}

                      <TextField
                        fullWidth
                        type="number"
                        label="Anzahl"
                        name="Amount"
                        value={_order.Amount}
                        onChange={(ev) => this.handleAmountChange(ev, _order.orderID)}
                        inputProps={{ min: 1 }}
                        sx={{ mb: 3 }}
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={_order.Confirmed || false}
                            onChange={(ev) => this.handleConfirmedChange(ev, _order.orderID)}
                          />
                        }
                        label="Bestellung bestätigt"
                        sx={{ mb: 3 }}
                      />

                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<Refresh />}
                        onClick={() => this.resetEntry(_order.orderID)}
                        sx={{
                          borderRadius: '10px',
                          textTransform: 'none',
                          fontWeight: 600,
                          borderColor: '#ddd',
                          color: '#666',
                          '&:hover': {
                            borderColor: '#bbb',
                            bgcolor: '#f5f5f5'
                          }
                        }}
                      >
                        Zurücksetzen
                      </Button>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            </DialogContent>

            <Divider />

            <DialogActions sx={{ 
              p: { xs: 2, sm: 3 }, 
              gap: { xs: 1.5, sm: 2 },
              flexDirection: { xs: 'column', sm: 'row' }
            }}>
              <Button
                onClick={this.handleClose}
                variant="outlined"
                size="large"
                fullWidth
                sx={{
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#ddd',
                  color: '#666',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  order: { xs: 2, sm: 1 },
                  '&:hover': {
                    borderColor: '#bbb',
                    bgcolor: '#f5f5f5'
                  }
                }}
              >
                Schließen
              </Button>
              <Button
                type="submit"
                form="update-orders-form"
                variant="contained"
                size="large"
                fullWidth
                startIcon={<Save />}
                sx={{
                  bgcolor: '#2e7d32',
                  color: 'white',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                  order: { xs: 1, sm: 2 },
                  '&:hover': {
                    bgcolor: '#1b5e20',
                    boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                Bestellungen aktualisieren
              </Button>
            </DialogActions>
          </Dialog>
        )
        :
        <></>
    );
  }
}

export default UpdateCustomerProductsPopup;
